var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browser-url-form-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],ref:"inputSearch",attrs:{"type":"text","autofocus":"","placeholder":"URL"},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing)return;_vm.url=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }